import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@eres/forms-web/TextInputField";
import { getTenantDocType, TenantDocTypes } from "@eres/ejari-api/Entity";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { AttachmentInfo } from "@eres/ejari-api/Entity/tenant";

interface Props {
	index: number;
	document: AttachmentInfo;
	onDelete: ( doc: AttachmentInfo, index: number ) => void;
	onDocNameChange: ( doc: AttachmentInfo, index: number, name: string ) => void;
}

interface State {
	FileName?: string;
}

class TCDocument extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			FileName: props.document.FileName,
		};
	}

	UNSAFE_componentWillReceiveProps( nextProps: Readonly<Props> ): void {
		if ( nextProps ) {
			this.setState( {
				FileName: nextProps.document.FileName,
			} );
		}
	}

	render() {
		const { document, index, onDelete } = this.props;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
		};
		let docType = getTenantDocType( document );
		let preview = ( docType === TenantDocTypes.PDF ) ? <i className="icon-pdf-document"/> : getImagePreview( document );
		return <div className={ "mt-3 mb-2" }>
			<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
				<thead>
				<tr>
					<th>{ Strings.file }</th>
					<th>{ Strings.document_name }<span className="asterisk"> *</span></th>
					<th>{ Strings.action }</th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td data-label={ Strings.file }>{ preview }</td>
					<td data-label={ Strings.document_name }>
						<TextInputField
							{ ...filedProps }
							required={ true }
							id={ "FileName" }
							hideLabel={ true }
							onValueChange={ ( text: string ) => {
								this.onDocNameChange( document, index, text );
							} }
							error={ document.DocumentError }
							containerClassName="form-group mb-0"
						/>
					</td>
					<td data-label={ Strings.action }>
						<button
							className="btn btn-grey" onClick={ () => {
							onDelete( document, index );
						} }><i className="far fa-trash-alt"/>{ Strings.delete }
						</button>
					</td>
				</tr>
				</tbody>
			</table>
		</div>;
	}

	private onDocNameChange = ( doc: AttachmentInfo, index: number, text: string ) => {
		const { onDocNameChange } = this.props;
		onDocNameChange( doc, index, text );
	};
}

export function getImagePreview( tenantDoc: AttachmentInfo ) {
	let source = ( tenantDoc.LocalData && !isEmptyStringOrNull( tenantDoc.LocalData ) ) ?
		tenantDoc.LocalData : tenantDoc.DocumentURL;
	return <img src={ source } style={ { height: 40, width: 40 } } alt={ "uploaded_image" }/>;
}

export default TCDocument;
